import { render, staticRenderFns } from "./school_manage.vue?vue&type=template&id=6b2ebc48&scoped=true"
import script from "./school_manage.vue?vue&type=script&lang=js"
export * from "./school_manage.vue?vue&type=script&lang=js"
import style0 from "./school_manage.vue?vue&type=style&index=0&id=6b2ebc48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ebc48",
  null
  
)

export default component.exports